import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { PrefixUrlPipe } from '../../pipes/prefix-url.pipe';
import { EventqDialogPopover } from '../dialog-popover/dialog-popover';
import { EventqFlagAlarmToggle } from '../flag-alarm-toggle/flag-alarm-toggle';

@Component({
  selector: 'eventq-view-alarm-popover',
  imports: [EventqDialogPopover, EventqFlagAlarmToggle, PrefixUrlPipe],
  templateUrl: './view-alarm-popover.html',
  styleUrl: './view-alarm-popover.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqViewAlarmPopover {
  readonly open = input(false);
  readonly cameraName = input('');
  readonly urlValue = input('');
  readonly flagged = input(false);
  readonly hasPrevAlarm = input(true);
  readonly hasNextAlarm = input(true);
  readonly panelWidth = input<string | null>('1200px');
  readonly panelHeight = input<string | null>('910px');
  readonly panelMaxHeight = input<string | null>('910px');

  readonly closed = output<void>();
  readonly prevAlarm = output<void>();
  readonly nextAlarm = output<void>();
  readonly flaggedChange = output<boolean>();
}
